import Vue from 'vue'
import App from './App.vue'
import router from './router'
import FastClick from 'fastclick'
import '@/common/styles/index.scss'
import store from './store'
import 'amfe-flexible'

// 引入vant
import { Button, Cell, CellGroup, Field } from 'vant'
import 'vant/lib/index.css'
Vue.use(Button)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Field)

// import dolphinActivityEvent from 'dolphin-activity-event-dev'
// import 'dolphin-activity-event-dev/lib/style/index.css'
// Vue.use(dolphinActivityEvent)

// import muiEvent from 'mui-event'
// import 'mui-event/lib/index/index.css'
// Vue.use(muiEvent)
/* eslint-disable */
import { mxAddressPicker, mxImageResizer, mxLaunchApp, mxSignature, mxAddressInput } from 'mui-event-dev'
import 'mui-event-dev/lib/index/index.css'
Vue.use(mxAddressPicker)
Vue.use(mxImageResizer)
Vue.use(mxLaunchApp)
Vue.use(mxSignature)
Vue.use(mxAddressInput)

//引入 dolphinJsBridge
import JsBridge from '@dolphin-iot/jsbridge-sdk'
//引入dolphin 基座
import DolphinEngine from '@/plugins/dolphin.js'

import pkg from '../package.json'

if (process.env.VUE_APP_ENV === 'mock') {
  require('./mock')
}

Vue.config.productionTip = false

// eliminating 300ms delay between a physical tap
FastClick.attach(document.body)

if (
  process.env.NODE_ENV === 'development' ||
  process.env.VUE_APP_ENV === 'development' ||
  process.env.VUE_APP_ENV === 'mock'
) {
  //vConsole
  const vConsole = require('vconsole')
  new vConsole()
  console.info(`current version : v${pkg.version}`)
}

Vue.use(JsBridge)
Vue.use(DolphinEngine)

router.beforeEach((to, from, next) => {
  if (to) {
    // console.log(to.meta.title)
    document.title = to.meta.title
  }
  next()
})
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
